import Header from '../../components/Header'
import DesempenhoAnimalUsuario from '../../components/DesempenhoAnimalUsuario';
import DetalheProgressoUsuario from '../../components/DetalheProgressoUsuario';
import BackgroundSection from '../../components/BackgroundSection';
import FatosImportantes from '../../components/FatosImportantes';
import GraficoDetalheAnimal from '../../components/GraficoDetalheAnimal';
import styled from 'styled-components'
import React, { useEffect, useState } from "react";
import { ThreeDots } from "react-loader-spinner";
import { post } from '../../services/api';

const Container = styled.div`
    width: 100%;
`

function Animal() {
    const dadosRequisicao = JSON.parse(sessionStorage.getItem('dadosRequisicaoAnimal'));
    
    const [carregandoDados, setCarregandoDados] = useState(false);
    const [dadosAnimal, setDadosAnimal] = useState({});

    useEffect(() => {
        getDados();
    }, []);

    function getAnimalBGImagem() {
        switch (dadosRequisicao.idAnimal) {
            case 1:
                return 'leao';
            case 2:
                return 'tigre';
            case 3:
                return 'pinguim';
            case 4:
                return 'girafa';
            case 5:
                return 'zebrinha';
            case 6:
                return 'hipopotamo';
            case 7:
                return 'jaguar';
            case 8:
                return 'vaca-leiteira';
            case 10:
                return 'suricato';
            case 11:
                return 'zebra-velha';
        }
    }

    async function getDados() {
        try {
            const [mes, ano] = dadosRequisicao.mesAno.split('-');
            let requisicao;
            let response;
           
            setCarregandoDados(true);

            if (dadosRequisicao.cargo == 'GERENTE_REGIONAL') {
                requisicao = {
                    regiao: dadosRequisicao.regiao,
                    mes: mes,
                    ano: ano,
                    idAnimal: dadosRequisicao.idAnimal,
                };
                response = await post('/animais/getanimalregional', requisicao);

            } else {
                requisicao = {
                    vendedor: dadosRequisicao.vendedor,
                    mes: mes,
                    ano: ano,
                    idAnimal: dadosRequisicao.idAnimal,
                    detalhado: true
                };
                response = await post('/animais/getanimal', requisicao);
            }

            response.idAnimal = dadosRequisicao.idAnimal;
            response.animal = dadosRequisicao.nomeAnimal;
            response.indicador = dadosRequisicao.indicadorAnimal;
            response.mesAno = dadosRequisicao.mesAno;
            response.cargo = dadosRequisicao.cargo;
            
            setCarregandoDados(false);

            if (response.status === 'OK') {
                setDadosAnimal(response);
            } else {
                setDadosAnimal({});
            }
        } catch (error) {
            if (error.response) {
                console.error('Erro na resposta do servidor:', error.response.data);
            } else if (error.request) {
                console.error('Sem resposta do servidor:', error.request);
            } else {
                console.error('Erro durante a configuração da requisição:', error.message);
            }
        }
    }

    if (carregandoDados) {
        return (
            <>
                <Header type="otherPage" />
                <div className='flex justify-center items-center'>
                    <span className='text-xl'>Carregando Dados</span>
                    <ThreeDots
                        height="8"
                        width="60"
                        radius="15"
                        color="#000000"
                        ariaLabel="three-dots-loading"
                        wrapperStyle={{}}
                        wrapperClassName=""
                        visible={true}
                    />
                </div>
            </>
        )
    }

    if (!Object.keys(dadosAnimal).length) {
        return (
            <>
                <Header type="otherPage" />
                <div className='flex justify-center items-center'>
                    <span className='text-xl'>Sem dados no momento</span>
                </div>
            </>
        )
    }

    return (
        <div>
            <Header type="otherPage" />
                    <BackgroundSection imageName={getAnimalBGImagem()}>
                        <Container>
                            <DesempenhoAnimalUsuario dados={dadosAnimal} />
                        </Container>
                    </BackgroundSection>
                    {(dadosAnimal.dados && dadosAnimal.dados.length > 0 && Array.isArray(dadosAnimal.dados)) && (    
                        <DetalheProgressoUsuario dadosAnimal={dadosAnimal} />
                    )}

                    {dadosAnimal?.fatosImportantes && (
                        <FatosImportantes dadosAnimal={dadosAnimal} />
                    )}
                    {(dadosAnimal.graficoDiario && dadosAnimal.graficoDiario.length > 0) && (
                        <GraficoDetalheAnimal tipoGrafico={1} dadosAnimal={dadosAnimal} />
                    )}
                    {(dadosAnimal.graficoExcelenciaMensal && dadosAnimal.graficoExcelenciaMensal.length > 0) && (
                        <GraficoDetalheAnimal tipoGrafico={2} dadosAnimal={dadosAnimal} />
                    )}
        </div>
    )
}

export default Animal

